/**
 * Various modes the modal can be in
 *
 * @export
 * @enum {number}
 */
export var ModalManagerMode;
(function (ModalManagerMode) {
    ModalManagerMode["Open"] = "open";
    ModalManagerMode["Closed"] = "closed";
})(ModalManagerMode || (ModalManagerMode = {}));
//# sourceMappingURL=modal-manager-mode.js.map